const showMobileSearch = ({
  containerSelector = `.js-show-search`,
  modalSelector = `.js-show-form`,
  buttonSelector = `.js-show-btn`,
  showClass = `show`,
}) => {
  const modalContainers = document.querySelectorAll(containerSelector);

  if (modalContainers.length) {
    modalContainers.forEach((container) => {
      const modalElement = container.querySelector(modalSelector);
      const buttonElement = container.querySelector(buttonSelector);

      // Открытие модального окна
      const onButtonClick = () => {
        modalElement.style.width = `${getWidth()}px`;
        modalElement.classList.toggle(showClass);
        buttonElement.classList.toggle(showClass);
        if (buttonElement.classList.contains(showClass)) {
          document.body.addEventListener(`click`, onLayoutClick);
        } else {
          document.body.removeEventListener(`click`, onLayoutClick);
        }
      };

      const getWidth = () => {
        if (container.dataset.headerSearch) {
          const rightCoordinate = buttonElement.getBoundingClientRect().right;
          const windowWidth = document.documentElement.clientWidth;

          return windowWidth - rightCoordinate - 18;
        } else {
          const leftCoordinate = buttonElement.getBoundingClientRect().left;

          return leftCoordinate - 20;
        }
      };

      // Закртыие модального окна при клике вне окна
      const onLayoutClick = (evt) => {
        if (
          !evt.target.closest(containerSelector) ||
          evt.target.classList.contains(containerSelector)
        ) {
          onButtonClick();
        }
      };

      buttonElement.addEventListener(`click`, onButtonClick);
    });
  }
};

export default showMobileSearch;
